import { render, staticRenderFns } from "./SaleItemMini.vue?vue&type=template&id=0de2531c"
import script from "./SaleItemMini.vue?vue&type=script&lang=js"
export * from "./SaleItemMini.vue?vue&type=script&lang=js"
import style0 from "./SaleItemMini.vue?vue&type=style&index=0&id=0de2531c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports